<template>
  <nav class="flex flex-col items-start gap-3 text-sm sm:flex-row sm:flex-wrap sm:items-center" aria-label="Company navigation">
    <Button as-child variant="outline" size="lg" class="min-h-12 w-full text-base sm:w-fit">
      <RouterLink :to="{ name: 'HolidaysPublicUserCompaniesPage' }">
        <Building2 aria-hidden="true" />
        Change company
      </RouterLink>
    </Button>
    <RouterLink :to="{ name: 'HolidaysPublicCompanyPage', params: { companyUuid } }" class="min-w-0 max-w-full break-words text-primary underline-offset-4 hover:underline">
      {{ companyName || 'Company overview' }}
    </RouterLink>
  </nav>
</template>

<script setup>
import { Building2 } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

defineProps({
  companyUuid: { type: String, required: true },
  companyName: { type: String, default: '' },
})
</script>
